import mapValues from 'lodash/mapValues';
import content from './content/index.js';
import entitlement from './entitlement/index.js';
import experience from './experience/index.js';
import layout from './layout/index.js';
import customer from './customer/index.js';
import createAxiosInstance from './createAxiosInstance.js';
import './utils/index.js';
import './utils/normalizr/constants.js';
import './utils/normalizr/entities.js';
import './utils/normalizr/interfaces.js';
import './utils/normalizr/utils.js';
import './content/v1/index.js';
import './content/v1/asset.js';
import '@dtvgo/typed-normalizr';
import 'query-string';
import '@dtvgo/constants';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';
import './content/v1/shows.js';
import './content/v1/streaming.js';
import './content/v2/index.js';
import './content/v2/live.js';
import './entitlement/v3/index.js';
import './entitlement/v3/playback.js';
import './experience/v2/index.js';
import './experience/v2/learnActions.js';
import './experience/v3/index.js';
import './experience/v3/thinkAnalytics.js';
import './experience/v3/playback.js';
import './experience/v4/index.js';
import './experience/v4/playback.js';
import './layout/v3/index.js';
import './layout/v3/carousels.js';
import './layout/v3/pages.js';
import './layout/v4/index.js';
import './layout/v4/banner.js';
import './layout/v4/carousels.js';
import './layout/v4/pages.js';
import './customer/v1/index.js';
import './customer/v1/profile.js';
import './customer/v1/accounts.js';
import './customer/v1/legal.js';
import 'axios';
import '@dtvgo/axios-interceptor-auth';
import './interceptors/clientHeaders.js';

const services = {
  content,
  entitlement,
  experience,
  layout,
  customer
};
function createService(params) {
  const backendAxiosInstance = createAxiosInstance(params);
  return mapValues(
    services,
    (versions) => mapValues(versions, (version) => version(backendAxiosInstance))
  );
}

export { createService as default };
//# sourceMappingURL=createService.js.map
